"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterItem = void 0;
var _buttonsModule = _interopRequireDefault(require("@albelli/arc-3/lib/buttons.module.css"));
var _footerModule = _interopRequireDefault(require("@albelli/arc-3/lib/footer.module.css"));
var _logoModule = _interopRequireDefault(require("@albelli/arc-3/lib/logo.module.css"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FooterItem = _ref => {
  let {
    icon,
    img,
    text,
    href,
    className
  } = _ref;
  let innerItem = text;
  let listItem = true; //listItem = auto wrap (1 item per line)

  //arc3-icon specified - i.e. social icons
  if (icon) {
    listItem = false;
    innerItem = /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      className: "icon--background-color-brand-cyan icon-".concat(icon),
      size: "small",
      name: icon
    }, icon);
  }
  //if has img src - awards or payment options
  else if (img) {
    var _className$split;
    listItem = false;

    // Mapping i.e. "logo_arc3-payment logo_arc3-payment--ideal" to "logo_arc3-payment__1A3jL logo_arc3-payment--ideal__K7Q5q"
    const moduleClassName = className === null || className === void 0 || (_className$split = className.split(" ")) === null || _className$split === void 0 || (_className$split = _className$split.map(c => _logoModule.default[c] || _buttonsModule.default[c] || c)) === null || _className$split === void 0 ? void 0 : _className$split.join(" ");
    innerItem = /*#__PURE__*/_react.default.createElement("img", {
      loading: "lazy",
      className: moduleClassName,
      src: img,
      alt: text,
      width: "80",
      height: "30",
      style: {
        maxWidth: "200px"
      }
    });
  }
  //if it has a class it is a wrapped div icon - i.e. the app icons, else its just text
  else if (!!className) {
    innerItem = /*#__PURE__*/_react.default.createElement("div", {
      className: _footerModule.default[className] || className
    });
  }

  //if href wrap in an anchor
  if (href) {
    innerItem = /*#__PURE__*/_react.default.createElement("a", {
      href: href,
      alt: text
    }, innerItem);
  }
  return listItem ? /*#__PURE__*/_react.default.createElement("li", null, innerItem) : innerItem;
};
exports.FooterItem = FooterItem;